import application from 'application/application';

import moment from 'moment';

const controller = 'DefaultMovementsDetailsController';

application.controller(controller, [
	'$scope',
	'$http',
	'$state',
	'$stateParams',
	'$timeout',
	'$controller',
	'API',
	'helper',
	'notification',
	'authentication',
	'permissions',
	'environment',
	'googleAPI',
	'downloadService',
	'$rootScope',
	'integracaoGoogleCalendar', //aqui google agenda
	'$location',
	(
		$scope,
		$http,
		$state,
		$stateParams,
		$timeout,
		$controller,
		API,
		helper,
		notification,
		authentication,
		permissions,
		environment,
		googleAPI,
		downloadService,
		$rootScope,
		integracaoGoogleCalendar, //aqui google agenda
		$location
	) => {
		$scope.stateParams = $stateParams;

		$scope.productAdvise = authentication.getUserData('idProdutoAdvise');

		$scope.schedulePermission = false;

		$scope.printing = false;

		$scope.overMenuSchedule = false;

		$scope.disableMail = false;

		$scope.movementInAction = null;

		$scope.quantityPerPage = 20;

		$scope.movementId;

		$scope.allProcessInsideDetail = [];

		$scope.shouldDeleteDeadlineType = 'publicação'; // publicação, andamento
		$scope.shouldDeleteDeadlineOption = 1;

		$scope.deleteMultiple = false;

		$scope.isMobile =
			window && window.innerWidth && window.innerWidth <= 991 ? true : false;

		const dataSyncGoogle = integracaoGoogleCalendar.recoverInfos();

		$rootScope.noSync =
			dataSyncGoogle && dataSyncGoogle.sincronizado ? false : true;

		$scope.syncedAgenda =
			dataSyncGoogle && dataSyncGoogle.sincronizado ? true : false;

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');

		if ($scope.groupUserSelected == null || $scope.groupUserSelected == 'false')
			$scope.groupUserSelected = false;

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		$scope.userData = JSON.parse(
			localStorage.getItem('__authenticationUserData__')
		);

		if (localStorage.getItem('__hasGroupUserPermission__'))
			$rootScope.hasGroupUserPermission = JSON.parse(
				localStorage.getItem('__hasGroupUserPermission__')
			);
		else {
			$rootScope.hasGroupUserPermission = true;
		}

		$scope.tooltipSendEmail = 'Adicione mais emails separando por ";"';

		$scope.onInit = () => {
			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			} else {
				$scope.fetchDeadlineNotification();
			}
		};

		$scope.fetchDeadlineNotification = async () => {
			await $rootScope.fetchDeadlineNotificationId();

			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			}
		};

		permissions.loadPermissions().then(() => {
			$scope.schedulePermission = permissions.has('recordSchedule');
			$scope.processPermission = permissions.has('createMovements');
		});

		$scope.currentPageUrl = () => {
			const url = $location.$$url.split('/detalhes')[0];

			switch (url) {
				case '/movimentacoes/publicacoes/pastas':
					$scope.environmentPageMov = '3';
					break;
				case '/movimentacoes/publicacoes':
					$scope.environmentPageMov = '2';
					break;
				case '/movimentacoes/processos/pastas':
					$scope.environmentPageMov = '4';
					break;
				case '/movimentacoes/todas-conta':
					$scope.environmentPageMov = '1';
					break;
				default:
					break;
			}
		};

		$scope.currentPageUrl();
		$rootScope.verifyEnvironment($scope.environmentPageMov);

		// Data do dia em cadastrar prazo
		let defaultEmptyData = {
			_dia: moment().format('DD/MM/YYYY')
		};

		$rootScope.formCreatePrazo.taskToEdit = helper.cloneSimpleObject(
			defaultEmptyData
		);

		/** Marcar movimento como lido */
		const setMovementsAsRead = (folder = $stateParams.pasta) => {
			let movementsData = [];
			let movementData;

			if ($scope.thereGroupId != null) {
				movementData = {
					id: parseInt($stateParams.movementsID),
					idGrupoUsuarios: $scope.thereGroupId,
					idMovProcessoCliente: parseInt($stateParams.movementsIDs)
				};
				movementsData.push(movementData);
			} else {
				movementData = {
					id: parseInt($stateParams.movementsID),
					idMovProcessoCliente: parseInt($stateParams.movementsIDs)
				};
				movementsData.push(movementData);
			}

			$http({
				...helper.http(API.movementMarkAsRead, 'PUT'),
				data: {
					itens: movementsData
				},
				messageOverride: {
					success(response, notify) {
						let message = '';

						if ($stateParams.type == 'andamento')
							message = 'O andamento foi marcado como lido!';
						else message = 'A publicação foi marcada como lida!';

						notify.success(message);
					}
				}
			}).then(() => helper.changeCountUnreadMovements(folder));
		};

		$scope.agendasEvent = helper.responseStore();

		$scope.recordAgendas = responseStore => {
			const idUsuarioCliente =
				parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
				undefined;

			$http({
				...helper.http(API.agendas, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idUsuarioCliente: idUsuarioCliente
				}
			}).then(response => responseStore.setItems(response.data.itens));
		};

		$scope.selectedTypeEvent = null;

		$scope.eventsTypes = helper.responseStore();
		$scope.eventsNotifications = helper.responseStore();

		$scope.recordEventsTypes = responseStore => {
			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			$http({
				...helper.http(API.eventsTypes, 'GET'),
				params: {
					...helper.httpFields(['id,nome']),
					idCliente,
					ativo: true
				}
			}).then(({ data }) => {
				responseStore.setItems(data.itens);

				// Converte o array para uma string e armazena no Session Storage
				sessionStorage.setItem(
					'__EVENTS_TYPES__',
					JSON.stringify(responseStore.getItems())
				);

				$scope.typesOfEevents = responseStore.setItems(data.itens);

				$rootScope.formCreatePrazo.eventsTypes = responseStore;

				$scope.selectedTypeEvent = data.itens.find(
					item => item.nome == 'Prazo'
				);

				if ($rootScope.formCreatePrazo.idTipoCompromisso) {
					$rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso =
						$rootScope.formCreatePrazo.idTipoCompromisso;
					setTimeout(() => {
						$('#createEventSelectTaskTypeComponent').trigger('change');
					});
				}
			});
		};

		$scope.getScopedInputValue = scopedInput =>
			scopedInput && scopedInput.$viewValue;

		$('#modalCreateAgendaEventComponent').on('hide', () => {
			$rootScope.formCreatePrazo.taskToEdit.processo = {};

			return $scope.$resetFormValidation('createEvent')();
		});

		$scope.createAgendaOfEvents = async form => {
			$rootScope.creationEventLoading = true;

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			$scope.syncedAgenda = dataSync.sincronizado;

			const fields = [
				'titulo',
				'dataHora',
				'dataHoraInicio',
				'diaInteiro',
				'idOpcaoLembreteAgenda',
				'idLembrete',
				'idRepetEventoAgenda',
				'localizacao',
				// 'observacao',
				'idTipoEventoAgenda',
				'idMovProcessoCliente',
				'sincronizado'
			];

			let [
				titulo,
				dataHora = `${new Date().getHours()}:30`,
				dataHoraInicio = new Date().toLocaleDateString('pt-BR'),
				diaInteiro,
				idOpcaoLembreteAgenda = $rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.idNotificacaoCompromisso
					? $rootScope.formCreatePrazo.idNotificacaoCompromisso
					: -1,
				idRepetEventoAgenda = -1,
				localizacao,
				idProcesso,
				idTipoEventoAgenda,
				idMovProcessoCliente,
				idTipoCompromisso,
				eventoGoogleId,
				sincronizado
			] = fields.map(input => $scope.getScopedInputValue(form[input]));

			if (form['localizacao']) {
				localizacao = $scope.getScopedInputValue(form['localizacao']);
			}

			if (
				$rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.taskToEdit &&
				$rootScope.formCreatePrazo.taskToEdit.processo
			) {
				idProcesso =
					$rootScope.formCreatePrazo.taskToEdit.processo.idProcesso || null;
			}

			const endHour = $scope.getScopedInputValue(form.dataHoraFim);

			let importante, remoto, presencial;

			if (form && form['importante']) {
				importante =
					form['importante'].$viewValue || form['importante'].$modelValue;
			}

			if (form && form['presencial']) {
				presencial =
					form['presencial'].$viewValue || form['presencial'].$modelValue;
			}

			if (form && form['remoto']) {
				remoto = form['remoto'].$viewValue || form['remoto'].$modelValue;
			}

			const eventDate = `${dataHoraInicio.substr(3, 2)}-${dataHoraInicio.substr(
				0,
				2
			)}-${dataHoraInicio.substr(6)}`;

			let fixDate = eventDate.replace('-', '/').replace('-', '/');

			const initialDate = new Date(`${fixDate} ${dataHora}`);

			if (diaInteiro == true || dataHora == '') {
				dataHora = '23:59:59';
			}

			const finalDate = new Date(`${fixDate} ${dataHora}`);

			const HoraAtual = new Date();

			HoraAtual.setHours(HoraAtual.getHours());

			const hour = parseInt(dataHora.substr(0, 2), 10);

			if (hour >= 23) finalDate.setHours(23, 59);
			else if (diaInteiro) {
				finalDate.setHours(23, 59);
			} else {
				finalDate.setHours(endHour.substr(0, 2), endHour.substr(3, 2));
			}

			if (!$scope.validationHours(initialDate, finalDate, form)) return;

			const checkbox = document.querySelector(
				'#modalCreateAgendaEvent #sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				sincronizado = checkbox.checked;
			}

			const event = {
				titulo,
				dataHoraInicio: moment(initialDate).format('YYYY-MM-DDTHH:mm:ss'),
				dataHoraFim: moment(finalDate).format('YYYY-MM-DDTHH:mm:ss'),
				idAgenda: $rootScope.idAgenda,
				diaInteiro,
				idOpcaoLembreteAgenda,
				idRepetEventoAgenda,
				importante,
				localizacao,
				idProcesso,
				observacao: $rootScope.formCreatePrazo.taskToEdit.observacao,
				idTipoEventoAgenda: idTipoEventoAgenda
					? idTipoEventoAgenda
					: idTipoCompromisso,
				idCategoriaEventoAgenda:
					Number(idTipoCompromisso) === -3
						? $rootScope.formCreatePrazo.taskToEdit.idCategoriaEventoAgenda
						: undefined,
				eventoGoogleId,
				sincronizado: $scope.googleSync ? !sincronizado : false,
				idsMovProcessosVinculados: [
					{
						idMovProcessoCliente: idMovProcessoCliente
					}
				],
				remoto,
				presencial
			};

			event.observacao = $rootScope.configQuill.value;

			$scope.sendEvent = (event, fields, form) => {
				return $http({
					...helper.http(API.deadlineEvents, 'POST'),
					data: { itens: [event] },
					messageOverride: {
						success(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							notify.success(
								`${nameType} cadastrad${
									idTipoEventoAgenda == -1 ? 'a' : 'o'
								} com sucesso.`
							);
						}
					}
				})
					.then(() => {
						fields.map(inputKey =>
							helper.defer(() => {
								const $control = form[inputKey];

								if ($control) {
									switch (inputKey) {
										case 'idRepetEventoAgenda':
										case 'idOpcaoLembreteAgenda':
											$control.$setViewValue(-1);
											break;
										case 'idTipoCompromisso':
											$control.$setViewValue('');
											$control.$$ngModelSet('');
											$control.$$setModelValue('');
											break;
										case 'diaInteiro':
											$control.$setViewValue(false);
											$control.$$ngModelSet(false);
											$control.$$setModelValue(false);
											break;
										case 'dataHoraInicio':
											$control.$setViewValue(moment().format('DD/MM/YYYY'));
											break;
										case 'idTipoEventoAgenda':
										case 'idMovProcessoCliente':
											break;
										default:
											$control.$setViewValue('');
											break;
									}

									$control.$render();
								}
							})
						);

						$rootScope.formCreatePrazo.taskToEdit.processo = {};
						$scope.$resetFormValidation('createEvent')();

						$('#modalCreateAgendaEventComponent').modal('hide');

						$scope.recordMovements($scope.movements);
					})
					.finally(() => ($rootScope.creationEventLoading = false));
			};

			if (event.sincronizado) {
				await integracaoGoogleCalendar.insertGoogleEvent(event, fields, form);

				setTimeout(() => {
					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.recordMovements($scope.movements);
					$scope.$resetFormValidation('createEvent')();
				}, 1500);
			} else {
				delete event['eventoGoogleId'];

				$scope.sendEvent(event, fields, form);
			}
		};

		$scope.attachmentDownload = (attachmentId, fileType = 'pdf', printing) => {
			if (!printing) {
				$scope.printing = true;

				$http({
					...helper.http(API.attachmentDownload, 'GET', {
						ID: attachmentId
					}),
					params: {
						tipoArquivo: fileType,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					},
					responseType: 'blob'
				}).then(response => {
					const { data, status } = response;

					if (status > 299) {
						$timeout(() => {
							$scope.printing = false;
						}, 1000);

						if ($scope.movements.items[0].anexo[0].flArquivoRestrito == true) {
							return notification.danger(
								'Anexo restrito, as informações não podem ser acessadas.'
							);
						} else {
							return notification.danger('Download não concluído.');
						}
					}

					const regex = /filename=(.*);/;

					const contentDispositionHeader =
						response.headers()['content-disposition'] ||
						`attachment; filename=${Date.now()}.pdf; filename*=UTF-8''${Date.now()}.pdf`;

					const [, filename] = regex.exec(contentDispositionHeader);

					const file = new Blob([data], { type: 'application/pdf' });

					const linkEl = document.createElement('a');

					linkEl.href = URL.createObjectURL(file);

					linkEl.download = filename;

					document.body.appendChild(linkEl);

					linkEl.click();

					notification.success('Download concluído!');

					$timeout(() => {
						$scope.printing = false;
					}, 1000);
				});
			}
		};

		/** Instância de armazenamento de resposta. */
		$scope.movements = helper.responseStore();

		$scope.recordMovements = responseStore => {
			if (
				$stateParams.type == 'andamento' &&
				!permissions.has('createMovements')
			) {
				$scope.processMovements.setReady(true);

				$state.transitionTo('root.default.initial', {
					inherit: false,
					reload: true
				});

				return;
			}

			if ($stateParams.type == 'andamento') {
				$scope.shouldDeleteDeadlineType = 'andamento';
			} else {
				$scope.shouldDeleteDeadlineType = 'publicação';
			}

			responseStore.setReady(false);
			$http({
				...helper.http(
					$stateParams.type == 'andamento'
						? API.movementDetailsTypeProgress
						: API.movementDetailsTypePublication,
					'GET'
				),
				params: {
					...helper.httpFields(['*']),
					possuiDataLixeira: false,
					registrosPorPagina: -1,
					IDs: $stateParams.movementsIDs,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					idsGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			})
				.then(response => {
					if (response.data.itens == '') {
						$scope.listEmpty = true;

						return false;
					}

					let { numero } = response.data.itens[0];

					$scope.thereGroupId = response.config.params.idGrupoUsuarios;

					if (numero)
						$scope.numberPrincipalProcess = numero
							.replaceAll('-', '')
							.replaceAll('.', '');

					if (response.data.itens.length && !response.data.itens[0].lido) {
						let folder = response.data.itens[0].pastasMovimento.find(
							item => item.idTipoPasta === -2 || item.idTipoPasta === -3
						);

						setMovementsAsRead(folder ? folder.id : $stateParams.pasta);
					}

					if (response.data.itens[0].prazos.length) {
						!response.data.itens[0].prazos[0].id &&
							response.data.itens[0].prazos.splice(0, 1);
					}

					const prazos = response.data.itens[0].prazos;

					prazos.sort(rearrangeDeadline);

					$scope.displayDeadlines(prazos);

					$scope.movementId = $stateParams.movementsIDs;

					responseStore.setItems(response.data.itens);

					if ($stateParams.print)
						$timeout(() => {
							window.print();

							$timeout(() => $state.go('root.default.movements'), 300);
						}, 300);
				})
				.catch(() => {
					$scope.goBackMov();
				})
				.finally(() => {
					responseStore.setReady(true);

					$scope.truncatedText();
				});
		};

		/*
		 * Anderson Paul Cararo
		 * Criado: 09/29/2023
		 * Alterado: --
		 * Reordena prazos concluidos - Inicio
		 */
		function rearrangeDeadline(a, b) {
			if (a.concluido && !b.concluido) {
				return 1;
			} else if (!a.concluido && b.concluido) {
				return -1;
			} else {
				return 0;
			}
		}

		/*
		 * Anderson Paul Cararo
		 * Criado: 09/29/2023
		 * Alterado: --
		 * Reordena prazos concluidos - Fim
		 */

		/*
		 * Anderson Paul Cararo
		 * Criado: 03/08/2023
		 * Alterado: --
		 * Mostrar mais prazos - Inicio
		 */

		let itemsPerPage = 3;
		let currentPage = 0;

		$scope.textButton = 'Exibir mais +';

		$scope.displayDeadlines = deadline => {
			const start = currentPage;
			const end = itemsPerPage;

			$scope.objetosExibidos = deadline.slice(start, end);

			currentPage = 0;

			setTimeout(() => {
				$scope.trustAsHtml();
			}, 500);
		};

		$scope.trustAsHtml = function() {
			$scope.objetosExibidos.forEach((prazo, indexOf) => {
				let element = document.getElementById(`observation-${indexOf}`);

				element.innerHTML = prazo.observacao
					? prazo.observacao
					: 'Nenhuma Observação';
			});
		};

		$scope.toggleVisibility = deadline => {
			if ($scope.objetosExibidos.length > 3) {
				itemsPerPage = 3;
				currentPage = 0;
				$scope.displayDeadlines(deadline);

				$scope.textButton = 'Exibir mais +';
			} else {
				itemsPerPage = deadline.length;
				currentPage = 0;
				$scope.displayDeadlines(deadline);
				$scope.textButton = 'Exibir menos -';
			}
		};

		/*
		 * Anderson Paul Cararo
		 * Criado: 03/08/2023
		 * Alterado: --
		 * Mostrar mais prazos - Fim
		 */

		/*
		 * Anderson Paul Cararo
		 * Criado: 31/07/2023
		 * Alterado: 01/08/2023
		 * Limitador de caracteres titulo dos prazos - Inicio
		 */
		$scope.shortenText = (text, limit) => {
			if (text.length > limit) {
				return text.slice(0, limit) + '…';
			} else {
				return text;
			}
		};

		$scope.verifyShortenedText = (element, limit) => {
			if (element.textContent.length > limit) {
				const originalText = element.textContent;
				const shortenText = $scope.shortenText(originalText, limit);

				element.textContent = shortenText;
			}
		};

		$scope.truncatedText = () => {
			setTimeout(() => {
				const elements = document.getElementsByClassName('texto-truncado');
				const characterLimit = 43; // Defina o limite de caracteres desejado

				for (let i = 0; i < elements.length; i++) {
					const elemento = elements[i];

					$scope.verifyShortenedText(elemento, characterLimit);
				}
			}, 30);
		};
		/*
		 * Anderson Paul Cararo
		 * Criado: 31/07/2023
		 * Alterado: 01/08/2023
		 * Limitador de caracteres titulo dos prazos - Fim
		 */

		$scope.recordMovements($scope.movements);

		/**
		 *
		 */
		// $scope.printMovements = () => window.print();

		/**
		 *
		 */
		// $scope.downloadMovements = movements => {
		// 	if (!Array.isArray(movements)) movements = [movements];

		// 	window.open(
		// 		helper.http(API.movements, 'download').url +
		// 			'?IDs=' +
		// 			movements.map(item => item.id).join(','),
		// 		'_self'
		// 	);
		// };

		// Fecha modal de exluir movimentações
		$scope.closeModal = () => {
			$('.modal').modal('hide');
		};

		$scope.openModalForwardMovements = () => {
			$('#modalForwardMovements').modal('show');
		};

		/**
		 *
		 */
		$scope.forwardMovements = (responseStore, movements) => {
			if (!Array.isArray(movements)) movements = [movements];

			$http({
				...helper.http(API.movements, 'forward'),
				method: 'POST',
				data: {
					itens: movements
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(movements)
				)

				.finally(() => responseStore.setItemsAsNotBusy(movements));
		};

		$scope.setMovementsAsUnread = () => {
			$scope.printing = true;

			let mensagemSucesso = '';

			if ($stateParams.type == 'andamento') {
				mensagemSucesso = 'O andamento foi marcado como não lido!';
			} else if ($stateParams.type == 'publicacao') {
				mensagemSucesso = 'A publicação foi marcada como não lida!';
			} else {
				mensagemSucesso = 'A movimentação foi marcada como não lida!';
			}

			$http({
				...helper.http(API.movementMarkAsUnread, 'PUT'),
				data: {
					itens: [
						{
							idMovProcessoCliente: $stateParams.movementsIDs
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success(mensagemSucesso);
					}
				},
				noCancelOnRouteChange: true
			}).then(() => {
				if ($scope.movements.hasItems()) {
					let folder = $scope.movements
						.getItems()[0]
						.pastasMovimento.find(
							item => item.idTipoPasta === -2 || item.idTipoPasta === -3
						);

					helper.changeCountUnreadMovements(
						folder ? folder.id : $stateParams.pasta,
						'unread'
					);
				}

				$scope.goBackMov();

				$scope.printing = false;
			});
		};

		$scope.currentGroupPage = 1;
		$scope.totalGroupPages = 1;
		$scope.totalGroupRegisters = 0;

		$('#modalProcessListInDatailLabel').on(
			'shown.bs.modal',
			($scope.recordModalProcess = () => {
				let params = {
					paginaAtual: $scope.currentGroupPage,
					registrosPorPagina: 10,
					idTipoPasta: -3,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					campos: 'id, numeroProcesso, nome'
				};

				$http({
					...helper.http(API.briefcase, 'GET'),
					params: params
				}).then(response => {
					$scope.allProcessInsideDetail = response.data.itens;

					$scope.totalGroupPages = Math.ceil(
						$scope.allProcessInsideDetail[0].totalPasta / 10
					);
					$scope.totalGroupRegisters =
						response.data.paginacao.registrosPorPagina;
				});
			})
		);

		$scope.reloadProcessListInDatail = () => {
			$scope.currentGroupPage = 1;
		};

		$scope.nextGroupPage = () => {
			if ($scope.currentGroupPage < $scope.totalGroupPages) {
				$scope.currentGroupPage++;

				$scope.recordModalProcess();
			}
		};
		$scope.firstGroupPage = () => {
			$scope.currentGroupPage = 1;

			$scope.recordModalProcess();
		};

		$scope.prevGroupPage = () => {
			if ($scope.currentGroupPage > 1) $scope.currentGroupPage--;

			$scope.recordModalProcess();
		};

		$scope.lastGroupPage = () => {
			$scope.currentGroupPage = $scope.totalGroupPages;

			$scope.recordModalProcess();
		};

		$scope.setBriefcase = (briefcase, movement) => {
			$http({
				...helper.http(API.briefcase, 'set'),
				method: 'PUT',
				data: {
					idMovimentoProcessoCliente: $stateParams.movementsIDs,
					idPastaUsuarioCliente: briefcase.id,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			}).then(() => {
				$('#modalProcessListInDatailLabel').modal('hide');

				movement.pasta = briefcase.nome;
			});
		};

		$scope.areAllMovementsFavorites = movements => {
			let favorites = movements.filter(item => !!item.favorita);

			return favorites.length > 0 && favorites.length === movements.length;
		};

		/* Integração de Ações */

		$scope.openDeleteModal = movement => {
			$scope.movementInAction = movement;

			if ($rootScope.hasGroupUserPermission) {
				$rootScope.getDaysDeleteTrash();

				let el = $('#modalDeleteMovementNew');

				if (movement && movement.prazos && movement.prazos.length > 0) {
					el = $('#modalDeleteMovementWithDeadline');
				}

				el.modal && el.modal('show');
			} else if (!$rootScope.hasGroupUserPermission)
				$('#modalNotPermitted').modal('show');
		};

		$scope.setDeleteModal = () => {
			$scope.tituloModal = 'Deseja excluir a movimentação?';
			$scope.mensagemModal =
				' Ao excluir movimentações, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
			$scope.botaoConfirmarModal = 'Sim, quero excluir a movimentação';

			if ($stateParams.type == 'andamento') {
				$scope.tituloModal = 'Deseja excluir o andamento?';
				$scope.mensagemModal =
					'Ao excluir um andamento, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
				$scope.botaoConfirmarModal = 'Sim, quero excluir o andamento';
			} else if ($stateParams.type == 'publicacao') {
				$scope.tituloModal = 'Deseja excluir a publicação?';
				$scope.mensagemModal =
					'Ao excluir uma publicação, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
				$scope.botaoConfirmarModal = 'Sim, quero excluir a publicação';
			}
		};

		$scope.setDeleteModal();

		$scope.openModalEmail = () => {
			$rootScope.configSendEmail.action = $scope.movements.getItems()[0];
			$rootScope.configSendEmail.action.idMovProcessoCliente =
				$stateParams.movementsIDs;
			$rootScope.configSendEmail.route = 'movements';
			$rootScope.configSendEmail.title = 'Enviar por email';

			const el = $('#modalSendEmailComponent');

			el.modal && el.modal('show');
		};

		$scope.openModalDownload = () => {
			const el = $('#modalDownload');

			el.modal && el.modal('show');
		};

		$scope.email = '';

		/* Impressão de movimentos */

		$scope.printMovements = () => {
			$scope.printing = true;
			// const checkedItems = $scope.movements.getCheckedItems();

			// if (!movement && !checkedItems.length) return notification.danger('Nenhum movimento selecionado.');

			// const ids = checkedItems.length ? checkedItems.map(x => x.movimento.id).join() : movement.movimento.id.toString();

			$http({
				...helper.http(API.downloads, 'movements'),
				params: {
					ids: $stateParams.movementsIDs,
					tipoArquivo: 'pdf',
					quebrarPaginaImpressao: false,
					idGrupoMovimento:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				},
				responseType: 'blob',
				noCancelOnRouteChange: true
			}).then(response => {
				const { data, status } = response;

				const prevIframes = document.querySelectorAll('.__printable-pdf-frame');

				prevIframes.forEach(iframe => iframe.remove());

				if (status > 299)
					return notification.danger('Erro ao imprimir movimentações.');

				const file = new Blob([data], { type: 'application/pdf' });

				file
					.dataURL()

					.then(() => {
						const iframe = document.createElement('iframe');

						iframe.className = '__printable-pdf-frame';

						iframe.style.position = 'fixed';
						iframe.style.bottom = '-100vh';

						iframe.src = URL.createObjectURL(file);

						document.body.appendChild(iframe);

						iframe.contentWindow.focus();

						if (window.innerWidth >= 992)
							setTimeout(() => {
								iframe.contentWindow.print();
							}, 1);

						if (
							navigator.userAgent.indexOf('Firefox') !== -1 ||
							window.innerWidth < 992
						) {
							let newWindow = window.open(
								URL.createObjectURL(file),
								'name',
								'height=800,width=1000'
							);

							newWindow.focus();
							setTimeout(() => {
								newWindow.print();
							}, 2000);
						}
						$timeout(() => {
							$scope.printing = false;
						}, 300);
					})

					.finally(() => ($scope.movementInAction = null));

				// checkedItems.forEach(movement => movement.__checked__ = false);
			});
		};

		/* Integração de Downloads */

		$scope.downloadMovements = (fileType = 'pdf') => {
			const params = {
				ids: $stateParams.movementsIDs,
				tipoArquivo: fileType,
				idGrupoMovimento:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			const api = 'movements';

			downloadService.serviceDownload(params, api);
		};

		$scope.recordIntegration = async () => {
			//Recupera dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			//aqui google agenda
			if (!$scope.dataSync)
				await integracaoGoogleCalendar.permissionIntegracao();
			//Recupera os dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			$rootScope.sincronizacaoError =
				$scope.dataSync && !!$scope.dataSync.error;
			if ($scope.dataSync && $scope.dataSync.sincronizado) {
				$rootScope.emailGoogleAccount = true;
				$rootScope.emailGoogle = $scope.dataSync.email;
				$scope.sync = true;
			} else {
				$rootScope.emailGoogleAccount = $rootScope.sincronizacaoError
					? true
					: false;
				$rootScope.emailGoogle = false;
			}
			if ($rootScope.sincronizacaoError)
				$('#modalDisabledGoogleCalendarError').modal('show');
		};

		$scope.recordIntegration();

		$timeout(() => {
			$('#modalRecoverPastDeadlinesOneComponent').on(
				'hidden.bs.modal',
				function() {
					if ($rootScope.recoverPastDeadlinesClosingFromChoice) {
						$scope.sync = false;

						return;
					}

					if ($rootScope.formCreatePrazo.modalOpen == 'modalCreate') {
						$('#modalCreateAgendaEventComponent').modal('show');
					} else if ($rootScope.formCreatePrazo.modalOpen == 'modalEdit') {
						$('#modalEditAgendaEventComponent').modal('show');
					}
					$scope.sync = false;
				}
			);
		}, 5000);

		$scope.editTerm = async contentTerm => {
			let dataSync = {};

			//Recupera dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();
			const eventTypeId =
				contentTerm.idTipoCompromisso || contentTerm.idTipoEventoAgenda;

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				$scope.eventsTypes.getItems().length === 0 &&
					$scope.recordEventsTypes($scope.eventsTypes);

				$rootScope.formCreatePrazo.idTipoCompromisso = eventTypeId;

				const form = $rootScope.formCreatePrazo;

				const evento = {
					...helper.cloneSimpleObject(contentTerm),
					idTipoCompromisso: eventTypeId,
					_dia: moment(contentTerm.dataHoraInicio).format('DD/MM/YYYY'),
					_hora: moment(contentTerm.dataHoraInicio).format('HH:mm'),
					_horaFim: contentTerm.diaInteiro
						? '00:00'
						: moment(contentTerm.dataHoraFim).format('HH:mm'),
					processSelectedValue: ''
				};

				form.editProcessSelectedOptions = [];

				if (contentTerm.flProcessoAtivo) {
					const processo = evento.processo;

					const hasProcess =
						processo &&
						typeof processo === 'object' &&
						processo.id !== undefined &&
						processo.id !== null &&
						processo.id !== '' &&
						processo.nome !== undefined &&
						processo.nome !== null &&
						processo.nome !== '';

					if (hasProcess) {
						evento.processo = {
							...processo,
							nome: String(processo.nome)
						};

						evento.processSelectedValue = evento.processo.nome;

						form.editProcessSelectedOptions = [evento.processo];
					}
				} else {
					evento.processo = {};
					$rootScope.formCreatePrazo.editingAgendaEvent.processo = {};
				}

				form.editingAgendaEvent = evento;

				if (
					contentTerm.idProcesso &&
					contentTerm.numeroProcesso &&
					$rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.editingAgendaEvent
				) {
					let eventTypeIdAux = eventTypeId;

					const intimacoes = location.href.includes('intimacoes');
					const processos =
						location.href.includes('processos') ||
						location.href.includes('andamentos') ||
						location.href.includes('andamento');
					const publicacoes = location.href.includes('publicacoes');

					if (intimacoes) eventTypeIdAux = -3; // Intimações
					if (processos) eventTypeIdAux = -4; // Processos
					if (publicacoes) eventTypeIdAux = -2; // Publicações

					$rootScope.formCreatePrazo.editingAgendaEvent.processo = {
						id: contentTerm.idProcesso,
						nome: contentTerm.numeroProcesso,
						fixado: eventTypeIdAux == -4 || eventTypeIdAux == -1 ? true : false
					};
				}

				$rootScope.formCreatePrazo.idTipoCompromisso =
					contentTerm.idTipoEventoAgenda;

				$rootScope.initQuillEdit(
					$rootScope.formCreatePrazo.editingAgendaEvent.observacao,
					'edit'
				);

				$rootScope.formCreatePrazo.editingAgendaEvent.sincronizado = $rootScope
					.formCreatePrazo.editingAgendaEvent.eventoGoogleId
					? true
					: false;

				$rootScope.formCreatePrazo.editingAgendaEvent.dataCurtaFormatada = moment(
					$rootScope.formCreatePrazo.editingAgendaEvent.dataHoraInicio
				).format('DD/MM/YYYY');

				$('#modalEditAgendaEventComponent').modal('show');
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				contentTerm.sincronizado = false;

				$scope.guardDataPrazos = {
					func: contentTerm,
					modal: 'edit'
				};
			}
		};

		//Dessincroniza quando da erro na sincronização
		$scope.disconnectSyncError = async () => {
			$scope.loadingDisconnectError = true;

			let dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendarError').modal('hide');

			$scope.loadingDisconnectError = false;
			$rootScope.sincronizacaoError = false;

			if ($scope.guardDataPrazos.modal == 'edit') {
				$scope.editTerm($scope.guardDataPrazos.func);
			} else if ($scope.guardDataPrazos.modal == 'create') {
				$scope.checkSyncDeadlines(
					$scope.guardDataPrazos.func,
					$scope.guardDataPrazos.type
				);
			}

			$scope.recordMovements($scope.movements);
		};

		$rootScope.checkMovementsNoSync = () => {
			$rootScope.formCreatePrazo.editingAgendaEvent.sincronizado = true;
		};

		$scope.openModalUnlinkDeadlines = prazos => {
			$rootScope.formCreatePrazo.editingAgendaEvent = {
				...helper.cloneSimpleObject(prazos)
			};

			$('#modalUnlinkDeadlines').modal('show');
		};

		$scope.getUnlinkEventTypeLabel = () => {
			const event = $rootScope.formCreatePrazo.editingAgendaEvent || {};

			return String(event.tipoEvento || 'evento').toLocaleLowerCase('pt-BR');
		};

		$scope.isUnlinkEventTypeFeminine = () =>
			String($scope.getUnlinkEventTypeLabel()).toLocaleLowerCase('pt-BR') ===
			'tarefa';

		$scope.getUnlinkEventArticle = () =>
			$scope.isUnlinkEventTypeFeminine() ? 'a' : 'o';

		$scope.getUnlinkEventReferencePreposition = () =>
			$scope.isUnlinkEventTypeFeminine() ? '\u00e0' : 'ao';

		$scope.getUnlinkEventGenderSuffix = () =>
			$scope.isUnlinkEventTypeFeminine() ? 'a' : 'o';

		$scope.getAgendaEventTypeLabel = helper.getAgendaEventTypeLabel;

		$scope.getAgendaEventCompletedMessage = (agendaEvent, completed) => {
			const nameEvent =
				agendaEvent.idTipoEventoAgenda === -2
					? 'Prazo'
					: agendaEvent.idTipoEventoAgenda === -3
					? 'Compromisso'
					: 'Tarefa';

			const isTask = nameEvent === 'Tarefa';

			const marked = isTask ? 'marcada' : 'marcado';

			const completedText = completed
				? isTask
					? 'concluída'
					: 'concluído'
				: isTask
				? 'não concluída'
				: 'não concluído';

			return `${nameEvent} ${marked} como ${completedText}`;
		};

		$scope.confirmUnlinkDeadlines = () => {
			let iDs = [];

			iDs.push(
				$rootScope.formCreatePrazo.editingAgendaEvent.idVinculoMovimento
			);

			const request = $http({
				...helper.http(API.deadlineEvents, 'desvincular'),
				method: 'PUT',
				data: {
					iDs: iDs
				},
				messageOverride: {
					success(response, notify) {
						notify.success(
							helper.getAgendaEventUnlinkSuccessMessage(
								$rootScope.formCreatePrazo.editingAgendaEvent || {}
							)
						);
					},
					error(response, notify) {
						notify.danger('A movimentação continua vinculada!');
					}
				}
			});

			request.finally(() => {
				$('#modalUnlinkDeadlines').modal('hide');
				$scope.recordMovements($scope.movements);
			});

			return request;
		};

		$scope.finishDeadline = prazo => {
			$scope.printing = true;

			let concluido = !prazo.concluido;
			let path = concluido ? 'marcarConcluido' : 'desmarcarConcluido';

			$http({
				...helper.http(API.deadlineEvents, `${path}`),
				method: 'PUT',
				data: { ids: [prazo.id] },
				messageOverride: {
					success(response, notify) {
						notify.success(
							$scope.getAgendaEventCompletedMessage(prazo, concluido)
						);

						$timeout(() => {
							$scope.printing = false;
							$scope.updatingAgendaEvent = false;
						}, 1000);
					}
				}
			})
				.then(() => {
					$('#modalEditAgendaEventComponent').modal('hide');

					$scope.recordMovements($scope.movements);

					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('editTermEvent')();
				})
				.catch(() => {
					$timeout(() => {
						$scope.printing = false;
					}, 1000);

					const id = prazo.id;
					const agendaEventIndex = $scope.events
						.getItems()
						.findIndex(agendaEvent => agendaEvent.id === id);

					agendaEventIndex >= 0 &&
						($scope.events.items[agendaEventIndex] = {
							...prazo,
							concluido
						});
				});
		};

		$scope.toggleImportant = agendaEvent => {
			let nameEvent =
				agendaEvent.idTipoEventoAgenda == -2
					? 'Prazo'
					: agendaEvent.idTipoEventoAgenda == -3
					? 'Compromisso'
					: 'Tarefa';

			$scope.updateAgendaEvent(
				{
					...agendaEvent,
					importante: !agendaEvent.importante
				},
				!agendaEvent.importante
					? `${nameEvent} marcad${
							agendaEvent.idTipoEventoAgenda == -1 ? 'a' : 'o'
					  } como importante!`
					: `${nameEvent} desmarcad${
							agendaEvent.idTipoEventoAgenda == -1 ? 'a' : 'o'
					  } como importante!`,
				'edit'
			);
		};

		$scope.getData = function(event) {
			function formatTitleDate(dateValue) {
				var date = new Date(dateValue);

				if (isNaN(date.getTime())) {
					return '';
				}

				var formattedDate = moment(date)
					.locale('pt-br')
					.format('dddd, D [de] MMMM [de] YYYY');

				return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
			}
			function formatHour(dateValue) {
				var date = new Date(dateValue);

				var hours = date.getHours();
				var minutes = date.getMinutes();

				hours = hours < 10 ? '0' + hours : hours;
				minutes = minutes < 10 ? '0' + minutes : minutes;

				return hours + ':' + minutes;
			}

			function getHour() {
				if (event.diaInteiro) {
					return event.remoto || event.presencial ? 'Dia todo' : '(Dia todo)';
				}

				return formatHour(event.dataHoraInicio);
			}

			function getEndHour() {
				if (event.diaInteiro) {
					return '';
				}

				return formatHour(event.dataHoraFim);
			}

			function getPresencialRemoto() {
				if (event.presencial) {
					return ' (Presencial)';
				}

				if (event.remoto) {
					return ' (Remoto)';
				}

				return '';
			}

			var endHour = getEndHour();

			var endText =
				formatTitleDate(event.dataHoraInicio) +
				' · ' +
				getHour() +
				(endHour ? ' às ' + endHour : '') +
				getPresencialRemoto();

			return endText;
		};

		$scope.updateAgendaEvent = (agendaEvent, type, typeUpdate) => {
			$scope.printing = true;

			if (agendaEvent._hora === '') {
				agendaEvent._hora = '00:00';
			}

			const { _dia, _hora, ...event } = agendaEvent;

			let finalDate;

			if (_dia && _hora) {
				const eventDate = `${_dia.substr(3, 2)}-${_dia.substr(
					0,
					2
				)}-${_dia.substr(6)}`;

				const initialDay = parseInt(_dia.substr(0, 2));
				const initialMonth = parseInt(_dia.substr(3, 2)) - 1;
				const initialYear = parseInt(_dia.substr(6));
				const initialHour = parseInt(_hora.substr(0, 2));
				const initialMinute = parseInt(_hora.substr(3, 2));

				// event.dataHoraInicio = new Date(`${eventDate} ${_hora}`);
				event.dataHoraInicio = new Date(
					initialYear,
					initialMonth,
					initialDay,
					initialHour,
					initialMinute
				);

				const hour = parseInt(_hora.substr(0, 2), 10);

				finalDate = new Date(initialYear, initialMonth, initialDay);

				finalDate.setHours(
					(Number.isNaN(hour) ? event.dataHoraInicio.getHours() : hour) + 1,
					_hora.substr(3, 2)
				);

				let dataHoraFinal = new Date(`${eventDate} ${_hora}`);

				// aqui
				if (event.diaInteiro) {
					event.dataHoraInicio.setHours(0, 0, 0, 0);
					dataHoraFinal = new Date(finalDate).setHours(23, 59, 0, 0);

					event.dataHoraInicio = moment(
						new Date(event.dataHoraInicio).setHours(0, 0)
					).format('YYYY-MM-DDTHH:mm:ss');

					if (hour >= 23)
						event.dataHoraFim = moment(
							new Date(event.dataHoraFim).setHours(23, 59)
						).format('YYYY-MM-DDTHH:mm:ss');
					else
						event.dataHoraFim = moment(dataHoraFinal).format(
							'YYYY-MM-DDTHH:mm:ss'
						);
				} else {
					event.dataHoraInicio = moment(event.dataHoraInicio).format(
						'YYYY-MM-DDTHH:mm:ss'
					);

					if (hour >= 23)
						event.dataHoraFim = moment(
							new Date(event.dataHoraInicio).setHours(23, 59)
						).format('YYYY-MM-DDTHH:mm:ss');
					else
						event.dataHoraFim = moment(
							new Date(event.dataHoraInicio).setHours(
								new Date(event.dataHoraInicio).getHours() + 1
							)
						).format('YYYY-MM-DDTHH:mm:ss');

					// event.dataHoraFim = finalDate.toJSON();
				}
			}

			const checkbox = document.querySelector(
				'#modalEditAgendaEventComponent #edit-sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				event.sincronizado = !document.querySelector(
					'#modalEditAgendaEventComponent #edit-sincronizado'
				).checked;
			}

			if (
				moment(event.dataHoraInicio).isBefore(moment().format('YYYY/MM/DD')) &&
				$state.params.filtro == 'vencidos' &&
				event.sincronizado
			) {
				notification.danger(
					'Data de início deve ser igual ou superior ao dia de hoje!'
				);

				$scope.printing = false;

				$('#modalEditAgendaEventComponent').modal('hide');

				$rootScope.formCreatePrazo.taskToEdit.processo = {};
				$scope.$resetFormValidation('editTermEvent')();

				$scope.truncatedText();

				return false;
			}

			if (typeUpdate !== 'edit') {
				event.observacao = $rootScope.configQuill.value;
			}

			$scope.request = () =>
				$http({
					...helper.http(API.deadlineEvents, 'PUT'),
					data: { itens: [event] },
					messageOverride: {
						success(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							if (type === 'edit') {
								notify.success(
									`${nameType} editad${
										idTipoEventoAgenda == -1 ? 'a' : 'o'
									} com sucesso.`
								);
							} else if (type === 'done' && agendaEvent.concluido === false) {
								notify.success(
									$scope.getAgendaEventCompletedMessage(agendaEvent, false)
								);
							} else if (type === 'done' && agendaEvent.concluido === true) {
								notify.success(
									$scope.getAgendaEventCompletedMessage(agendaEvent, true)
								);
							} else if (type != 'edit' && type != 'done') {
								notify.success(type);
							}

							$timeout(() => {
								$scope.printing = false;
								$scope.updatingAgendaEvent = false;
							}, 1000);
						},
						error(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							notify.success(
								`${nameType} não ${
									type === 'done'
										? `concluíd${idTipoEventoAgenda == -1 ? 'a' : 'o'}`
										: `editad${idTipoEventoAgenda == -1 ? 'a' : 'o'}`
								}!`
							);

							$scope.updatingAgendaEvent = false;
							$timeout(() => {
								$scope.printing = false;
								$scope.updatingAgendaEvent = false;
							}, 1000);
						}
					}
				})
					.then(() => {
						$('#modalEditAgendaEventComponent').modal('hide');

						$scope.recordMovements($scope.movements);

						$rootScope.formCreatePrazo.taskToEdit.processo = {};
						$scope.$resetFormValidation('editTermEvent')();
					})

					.catch(() => {
						$timeout(() => {
							$scope.printing = false;
						}, 1000);

						const { id } = agendaEvent;
						const agendaEventIndex = $scope.events
							.getItems()
							.findIndex(agendaEvent => agendaEvent.id === id);

						agendaEventIndex >= 0 &&
							($scope.events.items[agendaEventIndex] = {
								...agendaEvent,
								concluido: agendaEvent.concluido
							});
					});

			if (event.sincronizado && !$rootScope.noSync) {
				if (agendaEvent.eventoGoogleId === 'true')
					delete agendaEvent.eventoGoogleId;

				let isInsert = Boolean(agendaEvent.eventoGoogleId);

				if (!isInsert && event.sincronizado) {
					//criar um evento na agenda
					integracaoGoogleCalendar.insertGoogleEvent(
						event,
						null,
						null,
						type,
						$scope.request
					);
				} else if ($state.params.filtro == 'vencidos' && event.eventoGoogleId) {
					//Excluir se for vencido
					integracaoGoogleCalendar.deleteGoogleEvent(event);

					setTimeout(() => {
						delete event.eventoGoogleId;

						integracaoGoogleCalendar.insertGoogleEvent(
							event,
							null,
							null,
							type,
							$scope.request
						);
					});
				} else {
					//atualizar evento ja existente
					integracaoGoogleCalendar.updateGoogleEvent(event, $scope.request);
				}
			} else {
				//atualizar apenas no sistema advise
				event.sincronizado = false;

				$scope.request();
			}
		};

		$scope.recordEvents = (responseStore, updateAgendaEvent) => {
			$scope.searchIcon = true;

			const filter = $scope.getActiveFilter();

			$scope.clear = false;

			const {
				titulo,
				paginaAtual = 1,
				rangeDataFim,
				rangeDataInicio,
				tipo: idTipoEventoAgenda,
				dataHoraInicial = new Date()
			} = $stateParams;

			if ($stateParams.titulo != undefined) {
				$scope.searchIcon = false;
				$scope.verifySearch = true;
			}

			const idUsuarioCliente = parseInt(
				authentication.getUserData('idUsuarioCliente'),
				10
			);

			const isValidEventTypeId =
				!Number.isNaN(parseInt(idTipoEventoAgenda, 10)) &&
				typeof parseInt(idTipoEventoAgenda, 10) === 'number';

			const isValidDateRange =
				!Number.isNaN(new Date(rangeDataInicio).getDate()) &&
				!Number.isNaN(new Date(rangeDataFim).getDate());

			const initialDate = !Number.isNaN(new Date(dataHoraInicial).getDate())
				? new Date(dataHoraInicial)
				: new Date();

			// Por padrão a hora da data do pârametro "DataInicial" é meia noite,
			// a não ser que seja o filtro para ver somente os eventos "vencidos",
			// que no caso seria às 23:59:59:999.
			// initialDate.setHours(0, 0, 0, 0);

			// const today = new Date(new Date().setHours(new Date().getHours() + 3));

			// Adiciona os parâmetros bases de todas as requisições de Eventos/Prazos da Agenda

			// \/ Validação para quando mudar para a última página e for o ultimo registro da pagina, e mudar para concluído/retirar check do concluído, não retornar “Não há prazos”. \/
			if (
				updateAgendaEvent &&
				responseStore.items.length === 1 &&
				responseStore.currentPage > 1
			) {
				$scope.notEnter = true;
				$scope.recordPrevPageAgendaEvents();
			} else {
				$scope.notEnter = false;
			}

			const params = {
				...helper.httpFields(['*']),
				ativo: true,
				idUsuarioCliente,
				paginaAtual: paginaAtual,
				ordenacao: '+dataHoraInicio',
				registrosPorPagina: responseStore.getItemsPerPage()
			};

			// Se não for o filtro do tipo "vencido", o parâmentro base da data é a "DataInicial"
			if (filter.name == 'vencendo') {
				// let dataInicio = new Date();

				// dataInicio.setHours(0, 0, 0, 0);

				params.dataInicial = moment().format('YYYY-MM-DD HH:mm:ss');
				//dataInicio.toJSON();
			}

			// Caso o filtro seja do tipo "vencido", o parâmentro base da data é a "DataFinal"
			if (filter.name === 'vencidos') {
				// initialDate.setHours(23,0,0,0);
				// let dataFim = new Date();

				// dataFim.setHours(dataFim.getHours() + 1);
				// dataFim.setMinutes(dataFim.getMinutes() - 1);
				params.dataFinal = moment().format('YYYY-MM-DD LTS'); //dataFim.toJSON();

				params.concluido = false;
			}

			if (filter.name === 'vencendo') params.concluido = false;

			// Caso seja o filtro do tipo "concluidos", adiciona o parâmetro "Concluido"
			if (filter.name === 'concluidos') {
				params.ordenacao = '+dataHoraUltAlteracao';
				params.concluido = true;
			}

			// Caso seja o filtro do tipo "importante", adiciona o parâmetro "Importante"
			if (filter.name === 'importantes') {
				params.concluido = false;

				params.importante = true;
			}

			// Filtro por título
			if (titulo) params.titulo = titulo;

			if (idTipoEventoAgenda && isValidEventTypeId)
				params.idTipoEventoAgenda = idTipoEventoAgenda;

			if (isValidDateRange) {
				params.dataInicial = moment(rangeDataInicio).format(
					'YYYY-MM-DD 00:00:00'
				);
				// if (filter.name === 'vencidos') {
				// 	params.dataFinal = moment(rangeDataFim).format('YYYY-MM-DD LTS');
				// 	$scope.clear = true;
				// } else {
				params.dataFinal = moment(rangeDataFim).format('YYYY-MM-DD 23:59:59');
				$scope.clear = true;
				// }
			}

			// Adiciona o estado de carregamento dos recursos
			responseStore.setLoading();

			// \/ Não repetir requisição \/
			if (!$scope.notEnter)
				$http({ ...helper.http(API.deadlineEvents, 'GET'), params })
					.then(response => {
						const { itens = [], paginacao = {} } = response.data;

						let now = moment();

						if (filter.name == 'vencendo' && response.data.itens)
							responseStore.setItems(
								response.data.itens.filter(item =>
									moment(item.dataHoraFim).isSameOrAfter(now, 'second')
								)
							);
						else responseStore.setItems(itens);

						// ou se o evento é hj o dia inteiro
						// if (item.diaInteiro == true && (moment(item.dataHoraInicio).isSame(now, 'day'))) {

						responseStore.__paginacao = paginacao;

						if (itens.length) {
							$scope.recordDaysEvents(initialDate);

							$scope.selectedDayEvents.setItems(
								itens.filter(({ dataEventoAgenda }) =>
									moment(dataEventoAgenda).isSame(moment(initialDate))
								)
							);

							$scope.options.onSelect(null, new Date(initialDate));

							if (itens[0]) {
								$scope.deadlinesLength = itens[0].totalRegistros || 0;

								$scope.deadlinesPagesLength = Math.ceil(
									$scope.deadlinesLength / responseStore.getItemsPerPage()
								);
							}
						}
					})

					.finally(() => responseStore.setReady(true));
		};

		$scope.recordEvents = (responseStore, updateAgendaEvent) => {
			$scope.searchIcon = true;

			const filter = $scope.getActiveFilter();

			$scope.clear = false;

			const {
				titulo,
				paginaAtual = 1,
				rangeDataFim,
				rangeDataInicio,
				tipo: idTipoEventoAgenda,
				dataHoraInicial = new Date()
			} = $stateParams;

			if ($stateParams.titulo != undefined) {
				$scope.searchIcon = false;
				$scope.verifySearch = true;
			}

			const idUsuarioCliente = parseInt(
				authentication.getUserData('idUsuarioCliente'),
				10
			);

			const isValidEventTypeId =
				!Number.isNaN(parseInt(idTipoEventoAgenda, 10)) &&
				typeof parseInt(idTipoEventoAgenda, 10) === 'number';

			const isValidDateRange =
				!Number.isNaN(new Date(rangeDataInicio).getDate()) &&
				!Number.isNaN(new Date(rangeDataFim).getDate());

			const initialDate = !Number.isNaN(new Date(dataHoraInicial).getDate())
				? new Date(dataHoraInicial)
				: new Date();

			// Por padrão a hora da data do pârametro "DataInicial" é meia noite,
			// a não ser que seja o filtro para ver somente os eventos "vencidos",
			// que no caso seria às 23:59:59:999.
			// initialDate.setHours(0, 0, 0, 0);

			// const today = new Date(new Date().setHours(new Date().getHours() + 3));

			// Adiciona os parâmetros bases de todas as requisições de Eventos/Prazos da Agenda

			// \/ Validação para quando mudar para a última página e for o ultimo registro da pagina, e mudar para concluído/retirar check do concluído, não retornar “Não há prazos”. \/
			if (
				updateAgendaEvent &&
				responseStore.items.length === 1 &&
				responseStore.currentPage > 1
			) {
				$scope.notEnter = true;
				$scope.recordPrevPageAgendaEvents();
			} else {
				$scope.notEnter = false;
			}

			const params = {
				...helper.httpFields(['*']),
				ativo: true,
				idUsuarioCliente,
				paginaAtual: paginaAtual,
				ordenacao: '+dataHoraInicio',
				registrosPorPagina: responseStore.getItemsPerPage()
			};

			// Se não for o filtro do tipo "vencido", o parâmentro base da data é a "DataInicial"
			if (filter.name == 'vencendo') {
				// let dataInicio = new Date();

				// dataInicio.setHours(0, 0, 0, 0);

				params.dataInicial = moment().format('YYYY-MM-DD HH:mm:ss');
				//dataInicio.toJSON();
			}

			// Caso o filtro seja do tipo "vencido", o parâmentro base da data é a "DataFinal"
			if (filter.name === 'vencidos') {
				// initialDate.setHours(23,0,0,0);
				// let dataFim = new Date();

				// dataFim.setHours(dataFim.getHours() + 1);
				// dataFim.setMinutes(dataFim.getMinutes() - 1);
				params.dataFinal = moment().format('YYYY-MM-DD LTS'); //dataFim.toJSON();

				params.concluido = false;
			}

			if (filter.name === 'vencendo') params.concluido = false;

			// Caso seja o filtro do tipo "concluidos", adiciona o parâmetro "Concluido"
			if (filter.name === 'concluidos') {
				params.ordenacao = '+dataHoraUltAlteracao';
				params.concluido = true;
			}

			// Caso seja o filtro do tipo "importante", adiciona o parâmetro "Importante"
			if (filter.name === 'importantes') {
				params.concluido = false;

				params.importante = true;
			}

			// Filtro por título
			if (titulo) params.titulo = titulo;

			if (idTipoEventoAgenda && isValidEventTypeId)
				params.idTipoEventoAgenda = idTipoEventoAgenda;

			if (isValidDateRange) {
				params.dataInicial = moment(rangeDataInicio).format(
					'YYYY-MM-DD 00:00:00'
				);
				// if (filter.name === 'vencidos') {
				// 	params.dataFinal = moment(rangeDataFim).format('YYYY-MM-DD LTS');
				// 	$scope.clear = true;
				// } else {
				params.dataFinal = moment(rangeDataFim).format('YYYY-MM-DD 23:59:59');
				$scope.clear = true;
				// }
			}

			// Adiciona o estado de carregamento dos recursos
			responseStore.setLoading();

			// \/ Não repetir requisição \/
			if (!$scope.notEnter)
				$http({ ...helper.http(API.deadlineEvents, 'GET'), params })
					.then(response => {
						const { itens = [], paginacao = {} } = response.data;

						let now = moment();

						if (filter.name == 'vencendo' && response.data.itens)
							responseStore.setItems(
								response.data.itens.filter(item =>
									moment(item.dataHoraFim).isSameOrAfter(now, 'second')
								)
							);
						else responseStore.setItems(itens);

						// ou se o evento é hj o dia inteiro
						// if (item.diaInteiro == true && (moment(item.dataHoraInicio).isSame(now, 'day'))) {

						responseStore.__paginacao = paginacao;

						if (itens.length) {
							$scope.recordDaysEvents(initialDate);

							$scope.selectedDayEvents.setItems(
								itens.filter(({ dataEventoAgenda }) =>
									moment(dataEventoAgenda).isSame(moment(initialDate))
								)
							);

							$scope.options.onSelect(null, new Date(initialDate));

							if (itens[0]) {
								$scope.deadlinesLength = itens[0].totalRegistros || 0;

								$scope.deadlinesPagesLength = Math.ceil(
									$scope.deadlinesLength / responseStore.getItemsPerPage()
								);
							}
						}
					})

					.finally(() => responseStore.setReady(true));
		};

		$scope.checkUnlinkDeadlines = fn => {
			$scope.syncedAgenda = localStorage.getItem('gapi') == 'false';

			const showMessage = localStorage.getItem('showSyncMessage') || 'true';

			$rootScope.noSync = JSON.parse(localStorage.getItem('__noSync__'));

			if (
				!$scope.syncedAgenda &&
				!$rootScope.emailGoogleAccount &&
				showMessage === 'true'
			)
				$('#modalUnlinkDeadlines').modal('show');
			else {
				$rootScope.modalAddEvent();
				fn();
			}
		};

		$scope.checkSyncDeadlines = async (fn, type) => {
			if ($scope.movements && $scope.movements.items.length > 0) {
				const movimento = $scope.movements.items[0];

				if (movimento.id && movimento.numeroProcesso) {
					$scope.processoEvento = {
						id: movimento.id,
						nome: movimento.pasta || movimento.numeroProcesso,
						fixado: true
					};
				}
			}

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				//Variavel que guarda se ta sincronizado ou não
				$scope.syncedAgenda = dataSync.sincronizado;

				//Guarda intimação a ser vinculada com prazo
				$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
					{
						idMovProcessoCliente: Number($stateParams.movementsIDs)
					}
				];

				//Variavel que guarda se ta sincronizado ou não, de forma geral '$rootScope'
				$rootScope.noSync = !dataSync.sincronizado ? true : false;
				$scope.modalAddEvent(type);

				//Verifica se e para mostrar mensagem de sincronização
				const showMessage = !integracaoGoogleCalendar.notAgainSincGoogleAgenda();

				if (!$scope.syncedAgenda && showMessage)
					$('#modalSyncAgenda').modal('show');
				else fn();
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				$scope.guardDataPrazos = {
					func: fn,
					modal: 'create',
					type
				};
			}
		};

		$rootScope.formCreatePrazo.getEventComponent = () => {
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		};

		/************* METODO PARA PASSAR EVENTO PRA SINCRONIZADO *************/
		$scope.modalAddEvent = type => {
			const eventType = Number(type) || void 0;

			$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
			$rootScope.formCreatePrazo.idTipoCompromisso = eventType;
			$rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso = eventType;
			setTimeout(() => {
				$('#createEventSelectTaskTypeComponent').trigger('change');
			});
		};
		/******************************** FIM ********************************/

		$scope.checksyncedAgenda = () => ($scope.syncedAgenda = true);

		$scope.showAgain = localStorage.getItem('__showSyncMessage__') || true;

		$scope.openCreateAgendaEventModal = () => {
			if (
				$scope.schedulePermission &&
				$scope.agendasEvent.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				!$rootScope.idAgenda && $scope.recordAgendas($scope.agendasEvent);
				$scope.recordEventsTypes($scope.eventsTypes);
			}

			$rootScope.formCreatePrazo.taskToEdit.processo = {
				...$scope.processoEvento
			};

			$('#modalCreateAgendaEventComponent').modal('show');
		};

		$scope.openEditTerm = () => {
			if (
				$scope.schedulePermission &&
				$scope.agendasEvent.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				!$rootScope.idAgenda && $scope.recordAgendas($scope.agendasEvent);
				$scope.recordEventsTypes($scope.eventsTypes);
			}

			$('#modalEditAgendaEventComponent').modal('show');
		};

		$scope.openUnlinkDeadlines = () => {
			if (
				$scope.schedulePermission &&
				$scope.agendasEvent.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				!$rootScope.idAgenda && $scope.recordAgendas($scope.agendasEvent);
				$scope.recordEventsTypes($scope.eventsTypes);
			}

			$('#modalUnlinkDeadlines').modal('show');
		};

		$scope.allProccesses = [];

		$scope.showAllProccess = ({ numero, processoPublicacao }) => {
			$scope.allProccesses = [];

			if (numero) {
				$scope.allProccesses.push({
					numeroProcesso: numero
				});

				let replaceNumber = numero.replaceAll(/\D+/g, '');

				$scope.allProccesses = [
					...$scope.allProccesses,
					...processoPublicacao.filter(({ flNumeroCNJ, numeroProcesso }) =>
						flNumeroCNJ
							? numeroProcesso !== replaceNumber
							: numeroProcesso !== numero
					)
				];
			} else {
				$scope.allProccesses = processoPublicacao;
			}

			$('#container-all-proccess').modal('show');
		};

		$scope.validationHours = (sDate, eDate) => {
			const startDate = moment(sDate);
			const endDate = moment(eDate);

			if (!startDate.isValid() || !endDate.isValid()) {
				notification.danger('Informe horários válidos para o compromisso.');

				$rootScope.creationEventLoading = false;

				return false;
			}

			if (endDate.isSameOrBefore(startDate)) {
				notification.danger(
					'Hora final cadastrada no compromisso não pode ser menor ou igual à hora inicial!'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			const diffInMinutes = endDate.diff(startDate, 'minutes');

			if (diffInMinutes < 15) {
				notification.danger(
					'O intervalo mínimo entre o horário de início e fim é de 15 minutos.'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			return true;
		};

		//************ Chama pararametros de usuarios *************************

		$scope.recordParametersUsers = () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			if (record) {
				$scope.parameterUsers = record;

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				$scope.quantityPerPage =
					$scope.parameterUsers.qtdRegistroMovPorPagina || 20;

				return $scope.quantityPerPage;
			}

			$http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			}).then(({ data: { itens } }) => {
				if (itens.length) {
					$scope.parameterUsers = itens[0];
					$scope.parameterUsers.idTipoVisualizacao = itens[0].idTipoVisualizacao
						? itens[0].idTipoVisualizacao
						: -1;
					itens[0];
					$scope.parameterUsers.qtdRegistroMovPorPagina = itens[0]
						.qtdRegistroMovPorPagina
						? itens[0].qtdRegistroMovPorPagina
						: 20;
				} else {
					$scope.parameterUsers = {
						qtdRegistroMovPorPagina: 20,
						idTipoVisualizacao: -1,
						exibirInfo: true
					};
				}

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				$scope.quantityPerPage =
					$scope.parameterUsers.qtdRegistroMovPorPagina || 20;

				sessionStorage.setItem(
					'parametros-usuarios',
					JSON.stringify($scope.parameterUsers)
				);
			});
		};

		//************************** FIM dos MÉTODOS **************************

		$scope.getAllMovements = async (filters, currentPage, position) => {
			if ($scope.loadingMore) return;

			$scope.loadingMore = true;

			const quantity = $scope.quantityPerPage || 20;

			$http({
				...helper.http(API.movementsClients, 'GET'),
				params: {
					...helper.httpFields(['*']),
					ordenacao: '-dataHoraInclusao',
					paginaAtual: currentPage,
					registrosPorPagina: quantity,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					...filters
				}
			})
				.then(({ data: { itens, paginacao } }) => {
					const movements = itens.map(item => {
						return {
							id: item.movimento.id,
							type: item.movimento.idTipoMovProcesso
						};
					});

					const movementsStorage = JSON.parse(sessionStorage.movements);

					const movementsArray =
						position === 'before'
							? [...movements, ...movementsStorage]
							: [...movementsStorage, ...movements];

					$timeout(() => {
						sessionStorage.movements = JSON.stringify(movementsArray);

						const currentIndex = $scope.getCurrentMovementIndex(movementsArray);

						$scope.setPrevNextItem(currentIndex, movementsArray);

						sessionStorage.paginacao = JSON.stringify(paginacao);
					}, 200);
				})
				.finally(() => ($scope.loadingMore = false));
		};

		$scope.getMovements = async (filters, currentPage, position) => {
			const quantity = await $scope.recordParametersUsers();

			if ($scope.loadingMore) return;

			$scope.loadingMore = true;

			$http({
				...helper.http(API.movements, 'GET'),
				params: {
					...helper.httpFields(['*']),
					ordenacao: '-dataHoraInclusao',
					paginaAtual: currentPage,
					registrosPorPagina: quantity,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					...filters
				}
			})
				.then(({ data }) => {
					const movements = data.itens.map(item => {
						return {
							id: item.movimento.id,
							type: item.movimento.idTipoMovProcesso
						};
					});

					const movementsStorage = JSON.parse(sessionStorage.movements);

					const movementsArray =
						position === 'before'
							? [...movements, ...movementsStorage]
							: [...movementsStorage, ...movements];

					$timeout(() => {
						sessionStorage.movements = JSON.stringify(movementsArray);

						const currentIndex = $scope.getCurrentMovementIndex(movementsArray);

						$scope.setPrevNextItem(currentIndex, movementsArray);

						sessionStorage.paginacao = JSON.stringify(data.paginacao);
					});
				})
				.finally(() => ($scope.loadingMore = false));
		};

		$scope.nextItem = null;
		$scope.prevItem = null;

		$scope.loadingMore = false;

		$scope.checkPreviousNextItems = () => {
			$timeout(() => {
				const movements = JSON.parse(sessionStorage.movements);

				const filters = JSON.parse(sessionStorage.filters || {});

				const pagination = JSON.parse(sessionStorage.paginacao);

				const allOfAccount = filters.IdPastaUsuarioCliente ? false : true;

				if (!movements) {
					$scope.nextItem = null;
					$scope.prevItem = null;

					return;
				}

				const currentIndex = $scope.getCurrentMovementIndex(movements);

				if (!$scope.loadingMore) {
					if (currentIndex < 5 && pagination.paginaAtual > 1) {
						if (!allOfAccount)
							$scope.getMovements(
								filters,
								pagination.paginaAtual - 1,
								'before'
							);
						else
							$scope.getAllMovements(
								filters,
								pagination.paginaAtual - 1,
								'before'
							);

						$timeout(
							() =>
								(sessionStorage.filters = JSON.stringify({
									...pagination,
									paginaAtual: pagination.paginaAtual - 1
								})),
							200
						);
					}

					if (
						currentIndex > movements.length - 6 &&
						pagination.paginaAtual < pagination.paginaTotal
					) {
						if (!allOfAccount)
							$scope.getMovements(filters, pagination.paginaAtual + 1, 'after');
						else
							$scope.getAllMovements(
								filters,
								pagination.paginaAtual + 1,
								'after'
							);
					}
				}

				$scope.setPrevNextItem(currentIndex, movements);
			}, 500);
		};

		$scope.getCurrentMovementIndex = movements => {
			return movements.findIndex(
				movement => movement.id == $stateParams.movementsIDs
			);
		};

		$scope.setPrevNextItem = (currentIndex, movements) => {
			if (currentIndex + 1 < movements.length)
				$scope.nextItem = movements[currentIndex + 1];

			if (currentIndex > 0) $scope.prevItem = movements[currentIndex - 1];
		};

		$scope.changePage = item => {
			if (!item) return;

			const stateName = `root.default.movements.list${$scope.environmentPageMov}.movementsDetails`;
			const params = {
				type: item.type == -1 ? 'andamento' : 'publicacao',
				movementsIDs: item.id
			};

			$state.go(stateName, params, {
				inherit: true,
				relative: $state.$current,
				notify: true
			});
		};

		$scope.checkPreviousNextItems();

		$scope.recordParametersUsers();

		$scope.restoreOrSend = (movements, request) => {
			if (!$scope.send) $scope.sendOrRestoreTrashCan(movements, request);
		};

		//Metodo que envia ou restaura movimento (ambiente de lixeira)
		$scope.sendOrRestoreTrashCan = (movements, request) => {
			if ($scope.send) return;

			$scope.send = true;

			let movData = [
				{
					idPasta: movements.idPasta || movements.idPastaUsuarioCliente || null,
					idMovimentoProcessoCliente: $stateParams.movementsIDs,
					excluirPrazosVinculados: $scope.shouldDeleteDeadlineOption == 2
				}
			];

			if ($scope.groupUserSelected)
				movData[0].idGrupoUsuarios = $scope.groupData.idGrupo;
			else movData[0].idUsuarioCliente = $scope.userData.idUsuarioCliente;

			if (movements.idAndamentoProcesso) movData[0].idPasta = movements.idPasta;

			const parseStorage = (storage, key, defaultValue) => {
				try {
					const value = storage.getItem(key);

					return value == null ? defaultValue : JSON.parse(value);
				} catch (error) {
					return defaultValue;
				}
			};
			const uniqueIds = ids =>
				ids
					.map(id => Number(id))
					.filter(
						(id, index, items) =>
							Number.isFinite(id) && id > 0 && items.indexOf(id) == index
					);
			const getIdsPastasPalavrasChave = palavrasChave =>
				uniqueIds(
					palavrasChave.map(
						palavraChave =>
							palavraChave.idPastaUsuarioCliente || palavraChave.id
					)
				);
			const getPalavrasChaveSelecionadas = () => {
				const palavrasChave = parseStorage(
					localStorage,
					'__keywordsChecked__',
					[]
				);

				if (palavrasChave.length) return palavrasChave;

				const selecionados = parseStorage(sessionStorage, '__selected__', {});
				const idsPalavrasChave = String(selecionados.IdsPalavraChave || '')
					.split(',')
					.filter(id => id);
				const palavrasChaveMenu =
					$rootScope.keyWordsMovements && $rootScope.keyWordsMovements.getItems
						? $rootScope.keyWordsMovements.getItems()
						: $rootScope.keyWordsMovements && $rootScope.keyWordsMovements.items
						? $rootScope.keyWordsMovements.items
						: [];

				return idsPalavrasChave
					.map(idPalavraChave =>
						palavrasChaveMenu.find(
							palavraChave => palavraChave.idPalavraChave == idPalavraChave
						)
					)
					.filter(palavraChave => palavraChave);
			};

			const palavrasChaveSelecionadas = getPalavrasChaveSelecionadas();
			const pastaModulo = sessionStorage.getItem('modulo-pasta');
			const idPastaAberta =
				$stateParams.pasta != null ? $stateParams.pasta : pastaModulo;
			const emTodasConta = $location.$$url.includes(
				'/movimentacoes/todas-conta'
			);
			const emPublicacoes = $location.$$url.includes(
				'/movimentacoes/publicacoes'
			);
			const emPastaPublicacao =
				$stateParams.folderType == -2 ||
				$location.$$url.includes('/movimentacoes/publicacoes/pastas') ||
				(parseStorage(sessionStorage, '__publicationPaste__', false) &&
					idPastaAberta != null);
			const possuiFiltroPalavraChave =
				(emTodasConta || emPublicacoes) && palavrasChaveSelecionadas.length > 0;
			const enviarPorPasta =
				request == 'send' && (emPastaPublicacao || possuiFiltroPalavraChave);

			let idsPastas = [];

			if (emPastaPublicacao && idPastaAberta != null)
				idsPastas = uniqueIds([idPastaAberta]);
			else if (possuiFiltroPalavraChave)
				idsPastas = getIdsPastasPalavrasChave(palavrasChaveSelecionadas);

			if (enviarPorPasta && idsPastas.length == 0)
				idsPastas = uniqueIds(movData.map(item => item.idPasta));

			const payload = {
				movimentosXPastas: movData.map(item => {
					const movimentoXPasta = { ...item };

					delete movimentoXPasta.idPasta;

					return movimentoXPasta;
				}),
				idsPastas
			};

			$http({
				...helper.http(
					API.trashCan,
					enviarPorPasta ? 'sendByFolders' : `${request}`
				),
				method: 'PUT',
				data: enviarPorPasta ? payload : movData,
				messageOverride: {
					success(response, notify) {
						const success =
							request == 'send'
								? 'Enviado para a Lixeira!'
								: 'Documento restaurado!';

						notify.success(success);
					},
					error(response, notify) {
						const error =
							request == 'send'
								? 'Erro ao enviar para Lixeira.'
								: 'Erro ao restaurar documento.';

						notify.danger(error);
					}
				},
				noCancelOnRouteChange: true
			})
				.then(response => {
					if (response.status != 500) {
						$rootScope.cleanSelectedMov();

						$scope.goBackMov();

						$('.modal').modal('hide');

						setTimeout(() => {
							$scope.send = false;
						}, 10);
					} else if (response.status == 500) {
						$('.modal').modal('hide');
						notification.danger('Erro ao enviar para Lixeira.');

						setTimeout(() => {
							$scope.send = false;
						}, 10);
					}
				})
				.catch(() => {
					setTimeout(() => {
						$scope.send = false;
					}, 100);
				});
		};

		$scope.goBackMov = () => {
			let params = helper.cloneSimpleObject($stateParams);

			$state.go(
				`root.default.movements.list${$scope.environmentPageMov}`,
				params,
				{
					inherit: false,
					reload: `root.default.movements.list${$scope.environmentPageMov}`
				}
			);
		};

		$rootScope.modalAddEvent = () => {
			$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
		};

		$scope.onInit();

		$scope.checkWidth = () => {
			let largura =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			return Boolean(largura <= 600);
		};

		$scope.modalSchedule = open => {
			$scope.overMenuSchedule = open;
		};

		$scope.goToSchedule = prazo => {
			if (prazo && prazo.id) {
				$http({
					...helper.http(API.deadlineEvents, 'GET'),
					params: {
						ids: prazo.id,
						ativo: true,
						paginaAtual: 1,
						registrosPorPagina: 10,
						campos: '*',
						ordenacao: '-diaInteiro,+dataHoraInicio'
					}
				}).then(response => {
					const { itens = [] } = response.data;

					if (itens && itens[0]) {
						localStorage.setItem(
							'__FORCE_OPEN_DETAILS__',
							JSON.stringify(itens[0])
						);

						const url = $state.href(
							'root.default.module-schedule',
							{},
							{
								absolute: true,
								inherit: false
							}
						);

						window.open(url, '_blank');
					}
				});

				return;
			}
		};

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});
	}
]);

export default controller;
